<template>
  <div id="restore-password">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-md-offset-3">
          <div class="login">
            <h2 class="section-title">Set New Password</h2>
            <p class="subtitle">
              Welcome {{ customer.first_name }} {{ customer.last_name }}! You can now restore your password.
            </p>
            <div class="alert alert-success" v-if="topMessage">
              <span>{{ topMessage }}</span>
            </div>
            <div class="alert alert-danger" v-if="topError">
              <span>{{ topError }}</span>
            </div>
            <form>
              <div :class="[password ? 'show-label' : '', 'form-group']">
                <label>Password</label>
                <input type="password" class="form-control" placeholder="Password" v-model="password" />
                <h6 class="text-danger small" v-if="passwordError">{{ passwordError }}</h6>
              </div>
              <div :class="[password_confirmation ? 'show-label' : '', 'form-group']">
                <label>Password Confirmation</label>
                <input type="password" class="form-control" placeholder="Password Confirmation" v-model="password_confirmation" />
              </div>
              <div class="form-group">
                <b-button variant="primary" class="pull-left" @click="setNewPassword($event)">Restore</b-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'set-password',
    data () {
      return {
        password: null,
        password_confirmation: null,
        passwordError: null,
        topMessage: null,
        topError: null,
        customer: {
          first_name: null,
          last_name: null
        }
      }
    },
    computed: {
      ...mapState({
        token: state => state.token,
        user: state => state.user
      })
    },
    props: {
      passwordToken: String
    },
    created () {
      if (this.token) {
        this.$router.push({ name: 'homepage' })
      }

      this.$store.dispatch('LoadingOn')
      this.$store.dispatch('GetCustomerByPasswordToken', {
        password_token: this.passwordToken
      })
        .then(response => {
          this.customer = response
          this.$store.dispatch('LoadingOff')
        })
        .catch(() => {
          this.$store.dispatch('LoadingOff')
          this.$router.push({ name: 'homepage' })
          this.notifyVue('danger', 'This is a non-existent customer.')
        })
    },
    methods: {
      setNewPassword (e) {
        e.preventDefault()

        this.$store.dispatch('LoadingOn')
        this.$store.dispatch('SetNewPassword', {
          password: this.password,
          password_confirmation: this.password_confirmation,
          password_token: this.passwordToken
        })
          .then(() => {
            this.passwordError = null
            this.topError = null
            this.topMessage = 'Your password has been successfully restored. You can now login into your account.'
            this.password = null
            this.password_confirmation = null
            this.$store.dispatch('LoadingOff')
          })
          .catch(error => {
            this.topMessage = null
            this.topError = error.errors.join(' ')
            this.passwordError = error.errors.password ? error.errors.password.join(' ') : null
            this.$store.dispatch('LoadingOff')
          })
      },
      notifyVue (type, message) {
        this.$notifications.notify({
          message: message,
          icon: '',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: type
        })
      }
    }
  }

</script>



// WEBPACK FOOTER //
// set-password.vue?2cef5ff4